import RouteManager from "@/lib/models/route-manager";
import flowManager from "@/lib/services/flow-manager";
import store from "@/store";

// Cards
import StoredValueCard from "@/forms/components/cards/stored-value-card";

// Credit Card
import CreditCard from "@/forms/components/cards/credit-card/eligibility";
import CreditCardOffer from "@/forms/components/cards/credit-card/offer";
import CreditCardNeedsReview from "@/forms/components/cards/credit-card/needs-review";
import CreditCardRejected from "@/forms/components/cards/credit-card/rejected";
import CreditCardOfferRejected from "@/forms/components/cards/credit-card/offer-rejected";
import CreditCardTechnicalError from "@/forms/components/cards/credit-card/technical-error";
//
//Stp Card
import StpCardSales from "@/forms/components/cards/stp-card/sales/referal";
import StpCard from "@/forms/components/cards/stp-card/eligibility";
import StpCardOffer from "@/forms/components/cards/stp-card/offer-credit-card";
import StpCardNeedsReview from "@/forms/components/cards/stp-card/needs-review";
import StpCardRejected from "@/forms/components/cards/stp-card/rejected";
import StpCardOfferRejected from "@/forms/components/cards/stp-card/offer-rejected";
import StpCardTechnicalError from "@/forms/components/cards/stp-card/technical-error";
//
//Eid

import EidCard from "@/forms/components/cards/eid/eligibility";
import EidCardOffer from "@/forms/components/cards/eid/offer-credit-card";
import EidCardNeedsReview from "@/forms/components/cards/eid/needs-review";
import EidCardRejected from "@/forms/components/cards/eid/rejected";
import EidCardOfferRejected from "@/forms/components/cards/eid/offer-rejected";
import EidCardTechnicalError from "@/forms/components/cards/eid/technical-error";
//Stp Loan

import StpLoan from "@/forms/components/loan/stp-loan/eligibility";
import StpLoanOffer from "@/forms/components/loan/stp-loan/offer";
import StpLoanNeedsReview from "@/forms/components/loan/stp-loan/needs-review";
import StpLoanRejected from "@/forms/components/loan/stp-loan/rejected";
import StpLoanOfferRejected from "@/forms/components/loan/stp-loan/offer-rejected";
import StpLoanTechnicalError from "@/forms/components/loan/stp-loan/technical-error";
//
//Auto Loan
import AutoLoan from "@/forms/components/loan/auto-loan/eligibility";
import AutoLoanOffer from "@/forms/components/loan/auto-loan/offer";
import AutoLoanNeedsReview from "@/forms/components/loan/auto-loan/needs-review";
import AutoLoanRejected from "@/forms/components/loan/auto-loan/rejected";
import AutoLoanOfferRejected from "@/forms/components/loan/auto-loan/offer-rejected";
import AutoLoanTechnicalError from "@/forms/components/loan/auto-loan/technical-error";
//
//Top Up
import StpTopUp from "@/forms/components/loan/stp-topup/eligibility";
import StpTopUpOffer from "@/forms/components/loan/stp-topup/offer";
import StpTopUpNeedsReview from "@/forms/components/loan/stp-topup/needs-review";
import StpTopUpRejected from "@/forms/components/loan/stp-topup/rejected";
import StpTopUpOfferRejected from "@/forms/components/loan/stp-topup/offer-rejected";
import StpTopUpTechnicalError from "@/forms/components/loan/stp-topup/technical-error";
//
//Auto Sales

import AutoSales from "@/forms/components/auto-loan/sales";
//
// Credit Card Aggregator
import CreditCardAggregator from "@/forms/components/cards/credit-card-aggregator/eligibility";
import CreditCardOfferAggregator from "@/forms/components/cards/credit-card-aggregator/offer";
import CreditCardNeedsReviewAggregator from "@/forms/components/cards/credit-card-aggregator/needs-review";
import CreditCardRejectedAggregator from "@/forms/components/cards/credit-card-aggregator/rejected";
import CreditCardOfferRejectedAggregator from "@/forms/components/cards/credit-card-aggregator/offer-rejected";
import CreditCardTechnicalErrorAggregator from "@/forms/components/cards/credit-card-aggregator/technical-error";
//
// Insurances
import Insurances from "@/forms/components/insurances";
import contactInformation from "@/forms/components/insurance/contact-information";
// Loan
import Error404 from "@/forms/components/404";
import Loan from "@/forms/components/loan/loans/eligibility";
import LoanOffer from "@/forms/components/loan/loans/offer";
import LoanNeedsReview from "@/forms/components/loan/loans/needs-review";
import LoanRejected from "@/forms/components/loan/loans/rejected";
import LoanOfferRejected from "@/forms/components/loan/loans/offer-rejected";
import LoanTechnicalError from "@/forms/components/loan/loans/technical-error";

// NBC
import NBCCard from "@/forms/components/nbc/card";
import NBCSTPCard from "@/forms/components/nbc/stp-card";
import NBCCardAggregator from "@/forms/components/nbc/card-aggregator";
import NBCSTPLoan from "@/forms/components/nbc/stp-loan";
import NBCStpTopUp from "@/forms/components/nbc/stp-topup";
import NBCCardCashBack from "@/forms/components/nbc/card-cash-back.js";
import NBCCardMiles from "@/forms/components/nbc/card-miles.js";
import NBCCardStoredValue from "@/forms/components/nbc/card-store-value.js";
import NBCLoan from "@/forms/components/nbc/loan";
import NBCSalesLoan from "@/forms/components/nbc/sales-loan";
import NBCSalesCard from "@/forms/components/nbc/sales-card";
import NBCProtect from "@/forms/components/nbc/insurance";
import NBCCardReader from "@/forms/components/nbc/card-reader";
import NBCAutoLoan from "@/forms/components/nbc/sales-auto-loan";
// Corporate
import DepositProduct from "@/forms/components/deposit-product/deposit-product";

//Merchant-loan
import MerchantLoan from "@/forms/components/merchant-loan/merchant-loan";

// Executive Referal
import Referal from "@/forms/components/executive/referal";
//Referral Program
import referralProgram from "@/forms/components/referral/referral-program";
//Lead Capture
import leadCapture from "@/forms/components/lead/lead-capture";
//Credit Card Digital
import onboardingDigital from "@/forms/components/cards/credit-card-digital/onboarding-digital";
import onboardingDigitalOffer from "@/forms/components/cards/credit-card-digital/offer";
import onboardingDigitalTechnicalError from "@/forms/components/cards/credit-card-digital/technical-error";
import onboardingDigitalRejected from "@/forms/components/cards/credit-card-digital/rejected";
import onboardingDigitalProgress from "@/forms/components/cards/credit-card-digital/progress-status";

const routeManagerInstance = new RouteManager({
  flowManager,
  store,
  mode: "history",
  routes: [
    {
      path: "/404/",
      name: "404",
      component: Error404
    },
    {
      path: "/loan/",
      name: "Deem | Loan Application", //'Loan eligibility',
      component: Loan
    },

    {
      path: "/loan/offer/",
      name: "Loan offer",
      component: LoanOffer
    },
    {
      path: "/loan/needs-review/",
      name: "Loan needs review",
      component: LoanNeedsReview
    },
    {
      path: "/loan/rejected/",
      name: "Loan rejected",
      component: LoanRejected
    },
    {
      path: "/loan/technical-error/",
      name: "Loan Technical Error",
      component: LoanTechnicalError
    },
    {
      path: "/loan/offer/rejected/",
      name: "Loan offer rejected",
      component: LoanOfferRejected
    },
    //Insurance
    {
      path: "/insurances/",
      name: "Insurances",
      component: Insurances
    },
    // {
    //   path: '/protect/',
    //   name: 'Deem | Insurance Application',
    //   component: contactInformation,
    // },
    //
    {
      //commented for the NBC deployment
      path: "/nbc/card/",
      name: "Deem | Credit Card", //'NBC Card',
      component: NBCCard
    },
    //NBC STP Card
    {
      path: "/nbc/stp-card/",
      name: "Deem | STP Card", //'NBC STP Card',
      component: NBCSTPCard
    },
    //NBC Card Aggregatpr
    {
      path: "/nbc/card-aggregator/",
      name: "Deem | Card Aggregator", //'NBC Card',
      component: NBCCardAggregator
    },
    //NBC STP Loan
    {
      path: "/nbc/stp-loan/",
      name: "Deem | STP Loan", //'NBC STP Loan',
      component: NBCSTPLoan
    },
    // //NBC Topup
    {
      path: "/nbc/stp-topup/",
      name: "Deem | STP Top Up", //'NBC STP Loan',
      component: NBCStpTopUp
    },
    //NBC Auto Loan

    {
      path: "/nbc/stp-auto-loan/",
      name: "Deem | NBC Auto Loan", //'NBC STP Loan',
      component: NBCAutoLoan
    },
    // {

    //     path: '/eid/reader/',
    //     name: 'Deem | EID', //'NBC STP Loan',
    //     component: NBCCardReader,
    // },
    //NBC Protect(Insurance)
    //  {
    //   path: '/nbc/protect/',
    //   name:'Deem | Protect', //'NBC STP Loan',
    //   component: NBCProtect,
    // },
    {
      path: "/nbc/card/cash-back/",
      name: "NBC Card CashBack",
      component: NBCCardCashBack
    },
    {
      path: "/nbc/card/miles/",
      name: "NBC Card Miles",
      component: NBCCardMiles
    },
    {
      path: "/nbc/card/stored-value/",
      name: "NBC Stored Value Card",
      component: NBCCardStoredValue
    },
    {
      //Commented for  to make NBC Loan as root page
      path: "/nbc/loan/",
      name: "Deem | Loan", //'NBC Loan',
      component: NBCLoan
    },
    {
      path: "/stored-value-card/",
      name: "Stored Value Card",
      component: StoredValueCard
    },
    //Digiatl Flow STP Credit Card
    {
      path: "/credit-card/",
      name: "Deem | Credit Card Application", //'Credit Card',
      component: CreditCard
    },
    {
      path: "/credit-card/offer/",
      name: "Credit Card Offer",
      component: CreditCardOffer
    },
    {
      path: "/credit-card/needs-review/",
      name: "Credit Card Needs Review",
      component: CreditCardNeedsReview
    },
    {
      path: "/credit-card/rejected/",
      name: "Credit Card Rejected",
      component: CreditCardRejected
    },
    {
      path: "/credit-card/technical-error/",
      name: "Credit Card Technical Error",
      component: CreditCardTechnicalError
    },
    {
      path: "/credit-card/offer/rejected/",
      name: "Credit Card Offer Rejected",
      component: CreditCardOfferRejected
    },
    //Stp Card
    {
      path: "/stp-card/",
      name: "STP Card", //'STP Card',
      component: StpCard
    },
    {
      path: "/stp-card/offer/",
      name: "STP Card Offer",
      component: StpCardOffer
    },
    {
      path: "/stp-card/needs-review/",
      name: "STP Card Needs Review",
      component: StpCardNeedsReview
    },
    {
      path: "/stp-card/rejected/",
      name: "STP Card Rejected",
      component: StpCardRejected
    },
    {
      path: "/stp-card/technical-error/",
      name: "STP Card Technical Error",
      component: StpCardTechnicalError
    },
    {
      path: "/stp-card/offer/rejected/",
      name: "STP Card Offer Rejected",
      component: StpCardOfferRejected
    },
    //
    //Eid journey
    {
      path: "/eid/card/",
      name: "Eid Card", //'STP Card',
      component: EidCard
    },
    {
      path: "/eid/card/offer/",
      name: "Eid Card Offer",
      component: EidCardOffer
    },
    {
      path: "/eid/card/needs-review/",
      name: "Eid Card Needs Review",
      component: EidCardNeedsReview
    },
    {
      path: "/eid/card/rejected/",
      name: "Eid Card Rejected",
      component: EidCardRejected
    },
    {
      path: "/eid/card/technical-error/",
      name: "Eid Card Technical Error",
      component: EidCardTechnicalError
    },
    {
      path: "/eid/card/offer/rejected/",
      name: "Eid Card Offer Rejected",
      component: EidCardOfferRejected
    },
    //Credit Card Aggergator
    {
      path: "/credit-card-aggregator/",
      name: "Deem | Credit Card Application | Aggregator", //'Credit Card',
      component: CreditCardAggregator
    },
    {
      path: "/credit-card-aggregator/offer/",
      name: "Credit Card Offer | Aggregator",
      component: CreditCardOfferAggregator
    },
    {
      path: "/credit-card-aggregator/needs-review/",
      name: "Credit Card Needs Review | Aggregator",
      component: CreditCardNeedsReviewAggregator
    },
    {
      path: "/credit-card-aggregator/rejected/",
      name: "Credit Card Rejected | Aggregator",
      component: CreditCardRejectedAggregator
    },
    {
      path: "/credit-card-aggregator/technical-error/",
      name: "Credit Card Technical Error | Aggregator",
      component: CreditCardTechnicalErrorAggregator
    },
    {
      path: "/credit-card-aggregator/offer/rejected/",
      name: "Credit Card Offer Rejected | Aggregator",
      component: CreditCardOfferRejectedAggregator
    },
    //
    //Stp Loan
    {
      path: "/stp-loan/",
      name: "STP Loan", //'STP Loan',
      component: StpLoan
    },
    {
      path: "/stp-loan/offer/",
      name: "STP Loan Offer",
      component: StpLoanOffer
    },
    {
      path: "/stp-loan/needs-review/",
      name: "STP Loan Needs Review",
      component: StpLoanNeedsReview
    },
    {
      path: "/stp-loan/rejected/",
      name: "STP Loan Rejected",
      component: StpLoanRejected
    },
    {
      path: "/stp-loan/technical-error/",
      name: "STP Loan Technical Error",
      component: StpLoanTechnicalError
    },
    {
      path: "/stp-loan/offer/rejected/",
      name: "STP Loan Offer Rejected",
      component: StpLoanOfferRejected
    },
    //
    //Auto Loan
    {
      path: "/stp-auto-loan/",
      name: "STP Auto Loan", //'STP Loan',
      component: AutoLoan
    },
    {
      path: "/stp-auto-loan/offer/",
      name: "Auto Loan Offer",
      component: AutoLoanOffer
    },
    {
      path: "/stp-auto-loan/needs-review/",
      name: "Auto Loan Needs Review",
      component: AutoLoanNeedsReview
    },
    {
      path: "/stp-auto-loan/rejected/",
      name: "Auto Loan Rejected",
      component: AutoLoanRejected
    },
    {
      path: "/stp-auto-loan/technical-error/",
      name: "Auto Loan Technical Error",
      component: AutoLoanTechnicalError
    },
    {
      path: "/stp-loan/offer/rejected/",
      name: "Auto Loan Offer Rejected",
      component: AutoLoanOfferRejected
    },

    //Top up
    {
      path: "/stp-topup/",
      name: "STP Top Up", //'STP Loan',
      component: StpTopUp
    },
    {
      path: "/stp-topup/offer/",
      name: "STP Top Up Offer",
      component: StpTopUpOffer
    },
    {
      path: "/stp-topup/needs-review/",
      name: "STP Top Up Needs Review",
      component: StpTopUpNeedsReview
    },
    {
      path: "/stp-topup/rejected/",
      name: "STP Top Up Rejected",
      component: StpTopUpRejected
    },
    {
      path: "/stp-topup/technical-error/",
      name: "STP Top Up Technical Error",
      component: StpTopUpTechnicalError
    },
    {
      path: "/stp-topup/offer/rejected/",
      name: "Top Up Offer Rejected",
      component: StpTopUpOfferRejected
    },
    //
    {
      path: "/deposit-product/",
      name: "Deem | Deposit Product",
      component: DepositProduct
    },
    {
      path: "/merchant-loan/",
      name: "Deem | Merchant Loan",
      component: MerchantLoan
    },
    //sales
    // {
    //   //Commented for  to make NBC Loan as root page
    //    path: '/nbc/sales-loan/',
    //    name:'Deem | Sales Loan', //'NBC Loan',
    //    component: NBCSalesLoan,
    //  },
    //  {
    //   //Commented for  to make NBC Loan as root page
    //    path: '/nbc/sales-card/',
    //    name:'Deem | Sales Credit Card', //'NBC Loan',
    //    component: NBCSalesCard,
    //  },
    // {
    //   path: '/executive/referal/',
    //   name: 'Deem | Executive Referal',
    //   component: Referal,
    // },
    {
      path: "/stp/sales/",
      name: "Deem | Stp Sales",
      component: StpCardSales
    },
    //Rferral Program
    {
      path: "/referral/",
      name: "Deem | Referral Program",
      component: referralProgram
    },
    //leadCapture
    {
      path: "/lead-page/start/",
      name: "Deem | Lead Capture",
      component: leadCapture
    },
    //Auto Sales
    {
      path: "/auto/sales/",
      name: "Deem | Auto Sales",
      component: AutoSales
    }
    // Credit Card Digital
    // {
    //     path: '/onboarding-digital/',
    //     name: 'Deem | Onboarding Digital',
    //     component: onboardingDigital,
    // },
    // {
    //     path: '/onboarding-digital/offer/',
    //     name: 'Onboarding Digital | Offer',
    //     component: onboardingDigitalOffer,
    // },
    // {
    //     path: '/onboarding-digital/technical-error/',
    //     name: 'Onboarding Digital | Technical Error',
    //     component: onboardingDigitalTechnicalError,
    // },
    // {
    //     path: '/onboarding-digital/rejected/',
    //     name: 'Onboarding Digital | Rejected',
    //     component: onboardingDigitalRejected,
    // },
    // {
    //     path: '/onboarding-digital/progress/',
    //     name: 'Onboarding Digital | Progress',
    //     component: onboardingDigitalProgress,
    // },
  ]
});

export default routeManagerInstance;
